var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvliFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 46,
    viewBox: "0 0 210 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.1 3.0502L64.5 15.0502L63.4 1.4502H44.8H34L36.2 4.6502V41.3502L34 44.5502H63.4L64.5 30.8502L56.1 42.9502H46.1V23.7502H51.6L56.2 30.3502V15.5502L51.6 22.1502H46.1V3.0502H56.1Z",
    fill: "#0F2D46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.2 3.45L97 28.95L87.5999 3.45L92.3 0.25H73.5L77.2 3.45L92.8 45.75L107.8 3.45L112.4 0.25H102L106.2 3.45Z",
    fill: "#0F2D46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.4 42.9502L133.5 4.6502L135.6 1.4502H121.4L123.5 4.6502V41.3502L121.4 44.5502H150.7L151.8 30.8502L143.4 42.9502H133.4Z",
    fill: "#0F2D46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.9 4.6502L175.1 1.4502H160.8L163 4.6502V41.3502L160.8 44.5502H175.1L172.9 41.3502V4.6502Z",
    fill: "#0F2D46"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvliFull);
export default __webpack_public_path__ + "static/media/EvliFull.087756fd143bac275f1ed22bea1097e3.svg";
export { ForwardRef as ReactComponent };